import { RadioButtonGroup } from '@sunwebgroup/ui-components/uds'
import { styled } from 'styled-components'

export const Column = styled(RadioButtonGroup)`=
  outline: none;
  height: fit-content;
  flex-basis: 100%;
`
